import React from "react";

export const LazyStringDateTimePicker = React.lazy(() =>
    import(
        /* webpackChunkName: "StringDateTimePicker" */ "./StringDateTimePicker"
    ).then(module => ({ default: module.StringDateTimePicker }))
);

export const LazyDateTimePicker = React.lazy(() =>
    import(/* webpackChunkName: "DateTimePicker" */ "./DateTimePicker").then(
        module => ({ default: module.DateTimePicker })
    )
);
